export const SMOKE_TEST_HISTORY_PATH_NAME = 'smoke-test/history';
